import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface PermissionItem {
    screen_id: string;
    view: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
    is_visible: boolean;
}

export interface ManageRoleScreenYGPermissionPayload {
    role_id: number;
    yeargroup_country_map_id?: number | null;
    permissions: PermissionItem[];
}

export const ManageRoleScreenYGPermissionSlice = createSlice({
    name: "ManageRoleScreenYGPermission",
    initialState: {} as IReduxState<any>,
    reducers: {
        manageRoleScreenYGPermission: (state, action: PayloadAction<ManageRoleScreenYGPermissionPayload>) => {
            state.isLoading = true;
        },
        successManageRoleScreenYGPermission: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureManageRoleScreenYGPermission: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        clearManageRoleScreenYGPermission: (state) => {
            state.data = undefined;
        }
    },
});

export const {
    manageRoleScreenYGPermission,
    successManageRoleScreenYGPermission,
    failureManageRoleScreenYGPermission,
    clearManageRoleScreenYGPermission
} = ManageRoleScreenYGPermissionSlice.actions;

export default ManageRoleScreenYGPermissionSlice.reducer;
